import { render, staticRenderFns } from "./BasicPageLeft.vue?vue&type=template&id=046f13ff&scoped=true"
import script from "./BasicPageLeft.vue?vue&type=script&lang=js"
export * from "./BasicPageLeft.vue?vue&type=script&lang=js"
import style0 from "./BasicPageLeft.vue?vue&type=style&index=0&id=046f13ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f13ff",
  null
  
)

export default component.exports